<template>
  <div class="user_personage" ref="userContent"   v-loading="loading">
    <nav-exhibition :currentIndex="1"/>
<!--    <div class="bg-wrap" >-->
<!--        <div  ></div>-->
<!--         <div  :style="{height:height+ 'px'}"></div>-->
<!--    </div>-->
    <div class="content">
      <el-row style="">
        <user-menu :language="language" @resizebg="getContentWrapHeight"/>
        <router-view></router-view>
      </el-row>
    </div>
    <footer-blogroll style="" :language="language"/>
  </div>
</template>
<script>
  import {language} from "../../../language/get";
  import NavExhibition from "../../../components/NavExhibition/index";
  import footerBlogroll from "../../../components/FooterBlogroll/footerBlogroll";
  import userMenu from "../../user/usermenu/usermenu";
import { setTimeout } from 'timers';


  export default {
    components: {
      NavExhibition,
      footerBlogroll,
      userMenu
    },
    data() {
      return {
        language: language(),
        bgList:[],
        height:100,
        loading:false,
        url:sessionStorage.getItem("url")
      }
    },
    mounted(){
        //this.loading = true;
       this.height =document.body.clientHeight ;
      this.getContentWrapHeight();

    },
    methods: {
      getContentWrapHeight(path){
          this.$nextTick(()=>{
            // let contentWrapHeight = this.$refs.userContent.offsetHeight;
            // console.log( document.body.clientHeight)

            // let bgListLength = Math.ceil(( document.body.clientHeight - 530) / 400);
            // if(path == '/broadcastoto' || path == '/experience' || path == '/visitortickets' || path == '/make' || path == '/exhibitionList/guestList' || path == '/'){
            //   this.bgList.length = bgListLength;
            // }else{
            //   this.bgList.length = bgListLength + 1;
            // }
            let that = this;

             setTimeout(function(){

                that.height = document.body.scrollHeight - 600;
                that.loading = false;
                that.$forceUpdate()
             },400)
          })
      },
    },
    watch:{
    //   $route(to,from){


    //       const that = this;



    //       that.loading = true;
    //       console.log(document.querySelectorAll(".infoPub")[0].clientHeight);
    //         that.getContentWrapHeight(to.path);

    //   },
    '$store.state.user.api': function () {
      this.getContentWrapHeight();
    }

    },
  }
</script>
<style scoped>
  .content {
    width: 1200px;
    min-height: 611px;
    margin: 0 auto;
    margin-bottom: 40px;
    margin-top: 20px

  }

  .user_personage {
    width: 100%;
    background: #f1f5fe;
    min-width:1200px;
  }


.bg-wrap{
  width: 100%;
  min-width: 1200px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  z-index: 0;
  background-color: #f1f5fe;
}
.bg-wrap div:nth-child(2n-1){
  width: 100%;
  height: 400px;
  /*background: url('../../../assets/index-bg-2.jpg');*/
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-wrap div:nth-child(2n){
  width: 100%;
  height: 400px;
  /*background: url('../../../assets/index-bg-1.jpg');*/
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-wrap div:first-child{
  /* background: #0c6dce !important; */
  /* background-size: 100% 100%;
  background-repeat: no-repeat; */
}
/* .bg-wrap div:nth-last-child(2){
  background: #0c6dce !important;
} */
.bg-wrap div:last-child{
  background-color: #f1f5fe;
  /*background: #0c6dce !important;*/
  /* background-size: 100% 100%;
  background-repeat: no-repeat; */
}
</style>
